import React from 'react';
import LazyLoad from 'react-lazyload';
import '../styles.css';

function ImgLazyLoad({children, ...props}) {
    return(
        <LazyLoad once>
            {children}
        </LazyLoad>
    )
};

export default ImgLazyLoad;